exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-container[data-v-3f56ef61]{display:grid;grid-template-columns:35px auto;-ms-flex-align:center;align-items:center;font-size:14px}.icon[data-v-3f56ef61]{vertical-align:bottom}.info-box[data-v-3f56ef61]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;color:gray;font-size:14px;margin-bottom:20px;gap:8px}.payment-info-form[data-v-3f56ef61]{margin-top:10px}.grid-gap-1[data-v-3f56ef61]{display:grid;gap:1rem}@media(max-width: 575px){.col-xs-hidden[data-v-3f56ef61]{display:none}.col-xxs-12[data-v-3f56ef61]{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}}", ""]);

// exports
